import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export default function CookiePolicy() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-sky-50 to-blue-50">
      <div className="max-w-4xl mx-auto px-4 py-12">
        <button
          onClick={() => navigate('/')}
          className="flex items-center gap-2 text-gray-600 hover:text-gray-900 mb-8"
        >
          <ArrowLeft size={20} />
          Vissza a főoldalra
        </button>

        <div className="bg-white rounded-lg shadow-lg p-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-6">SÜTI (COOKIE) TÁJÉKOZTATÓ</h1>
          <p className="text-sm text-gray-500 mb-8">Hatályos: 2026.01.24. napjától</p>

          <div className="prose max-w-none">
            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">1. MI AZ A SÜTI (COOKIE)?</h2>
              <p className="text-gray-700 mb-4">
                A süti (cookie) egy kis adatfájl, amely a weboldal látogatásakor kerül a Felhasználó eszközére.
              </p>
              <p className="text-gray-700">
                A sütik célja a weboldal megfelelő működésének biztosítása, a felhasználói élmény javítása és bizonyos funkciók biztosítása.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">2. A SÜTIK HASZNÁLATÁNAK CÉLJA</h2>
              <p className="text-gray-700 mb-4">A Szolgáltató a sütiket az alábbi célokra használja:</p>
              <ul className="list-disc pl-6 text-gray-700 mb-4">
                <li>a webalkalmazás technikai működtetése;</li>
                <li>bejelentkezési munkamenetek kezelése;</li>
                <li>biztonsági funkciók biztosítása;</li>
                <li>előfizetések és jogosultságok kezelése;</li>
                <li>statisztikai elemzések készítése (Google Analytics).</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">3. A HASZNÁLT SÜTIK TÍPUSAI</h2>
              
              <h3 className="text-xl font-semibold text-gray-900 mb-3">3.1. Feltétlenül szükséges sütik</h3>
              <p className="text-gray-700 mb-4">
                Ezek a sütik a weboldal működéséhez elengedhetetlenek, nélkülük a Szolgáltatás nem használható megfelelően.
              </p>
              <div className="overflow-x-auto mb-6">
                <table className="min-w-full border border-gray-300">
                  <thead>
                    <tr className="bg-gray-100">
                      <th className="border border-gray-300 px-4 py-2 text-left">Süti neve</th>
                      <th className="border border-gray-300 px-4 py-2 text-left">Cél</th>
                      <th className="border border-gray-300 px-4 py-2 text-left">Lejárat</th>
                    </tr>
                  </thead>
                  <tbody className="text-gray-700">
                    <tr><td className="border border-gray-300 px-4 py-2">session_id</td><td className="border border-gray-300 px-4 py-2">Munkamenet azonosítása</td><td className="border border-gray-300 px-4 py-2">Böngésző bezárásáig</td></tr>
                    <tr><td className="border border-gray-300 px-4 py-2">auth_token</td><td className="border border-gray-300 px-4 py-2">Bejelentkezési állapot</td><td className="border border-gray-300 px-4 py-2">30 nap</td></tr>
                    <tr><td className="border border-gray-300 px-4 py-2">csrf_token</td><td className="border border-gray-300 px-4 py-2">Biztonsági védelem</td><td className="border border-gray-300 px-4 py-2">Munkamenet</td></tr>
                  </tbody>
                </table>
              </div>
              <p className="text-gray-700 mb-6">Ezekhez nem szükséges külön hozzájárulás.</p>

              <h3 className="text-xl font-semibold text-gray-900 mb-3">3.2. Funkcionális sütik</h3>
              <p className="text-gray-700 mb-4">
                Ezek a sütik lehetővé teszik a Felhasználó által választott beállítások (pl. nyelv, felület) megjegyzését.
              </p>
              <div className="overflow-x-auto mb-6">
                <table className="min-w-full border border-gray-300">
                  <thead>
                    <tr className="bg-gray-100">
                      <th className="border border-gray-300 px-4 py-2 text-left">Süti neve</th>
                      <th className="border border-gray-300 px-4 py-2 text-left">Cél</th>
                      <th className="border border-gray-300 px-4 py-2 text-left">Lejárat</th>
                    </tr>
                  </thead>
                  <tbody className="text-gray-700">
                    <tr><td className="border border-gray-300 px-4 py-2">user_preferences</td><td className="border border-gray-300 px-4 py-2">Felhasználói beállítások</td><td className="border border-gray-300 px-4 py-2">1 év</td></tr>
                    <tr><td className="border border-gray-300 px-4 py-2">cookie_consent</td><td className="border border-gray-300 px-4 py-2">Cookie hozzájárulás megjegyzése</td><td className="border border-gray-300 px-4 py-2">1 év</td></tr>
                  </tbody>
                </table>
              </div>
              <p className="text-gray-700 mb-6">Ezek használata a Felhasználó hozzájárulásán alapul.</p>

              <h3 className="text-xl font-semibold text-gray-900 mb-3">3.3. Statisztikai sütik (Google Analytics)</h3>
              <p className="text-gray-700 mb-4">
                Ezek a sütik anonim információkat gyűjtenek a weboldal használatáról, kizárólag a rendszer fejlesztése céljából.
              </p>
              <div className="overflow-x-auto mb-4">
                <table className="min-w-full border border-gray-300">
                  <thead>
                    <tr className="bg-gray-100">
                      <th className="border border-gray-300 px-4 py-2 text-left">Süti neve</th>
                      <th className="border border-gray-300 px-4 py-2 text-left">Cél</th>
                      <th className="border border-gray-300 px-4 py-2 text-left">Lejárat</th>
                    </tr>
                  </thead>
                  <tbody className="text-gray-700">
                    <tr><td className="border border-gray-300 px-4 py-2">_ga</td><td className="border border-gray-300 px-4 py-2">Google Analytics - egyedi látogató</td><td className="border border-gray-300 px-4 py-2">2 év</td></tr>
                    <tr><td className="border border-gray-300 px-4 py-2">_ga_[ID]</td><td className="border border-gray-300 px-4 py-2">Google Analytics - munkamenet</td><td className="border border-gray-300 px-4 py-2">2 év</td></tr>
                    <tr><td className="border border-gray-300 px-4 py-2">_gid</td><td className="border border-gray-300 px-4 py-2">Google Analytics - napi azonosító</td><td className="border border-gray-300 px-4 py-2">24 óra</td></tr>
                  </tbody>
                </table>
              </div>
              <p className="text-gray-700 mb-2">A Google Analytics sütik:</p>
              <ul className="list-disc pl-6 text-gray-700 mb-4">
                <li>IP anonimizálással működnek</li>
                <li>kizárólag összesített, anonim statisztikákat készítenek</li>
                <li>nem azonosítják személyesen a Felhasználót</li>
              </ul>
              <p className="text-gray-700 mb-4">Google adatvédelmi irányelvek: https://policies.google.com/privacy</p>
              <p className="text-gray-700">Ezek kizárólag a Felhasználó előzetes hozzájárulásával kerülnek alkalmazásra.</p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">4. HARMADIK FÉLTŐL SZÁRMAZÓ SÜTIK</h2>
              <p className="text-gray-700 mb-4">A weboldal egyes funkciói során harmadik fél szolgáltatásai kerülhetnek alkalmazásra:</p>
              
              <p className="text-gray-700 mb-2"><strong>4.1. Google Analytics (Google LLC)</strong></p>
              <ul className="list-none pl-6 text-gray-700 mb-4">
                <li>Cél: weboldal-statisztikák készítése</li>
                <li>Székhely: USA</li>
                <li>Adatvédelem: EU-US Data Privacy Framework</li>
                <li>Részletek: https://policies.google.com/privacy</li>
              </ul>

              <p className="text-gray-700 mb-2"><strong>4.2. Barion (Barion Payment Zrt.)</strong></p>
              <ul className="list-none pl-6 text-gray-700 mb-4">
                <li>Cél: online fizetések feldolgozása</li>
                <li>Székhely: Magyarország</li>
                <li>Részletek: https://www.barion.com/hu/adatvedelmi-tajekoztato/</li>
              </ul>

              <p className="text-gray-700 mb-2"><strong>4.3. Supabase (bejelentkezés)</strong></p>
              <ul className="list-none pl-6 text-gray-700 mb-4">
                <li>Cél: felhasználói hitelesítés</li>
                <li>Adatkezelés helye: Stockholm, Svédország (EU)</li>
              </ul>

              <p className="text-gray-700">
                Ezen szolgáltatók saját adatkezelési és süti szabályzatot alkalmaznak, amelyekért a Szolgáltató nem vállal felelősséget.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">5. A SÜTIK ÉLETTARTAMA</h2>
              <ul className="list-disc pl-6 text-gray-700 mb-4">
                <li>Munkamenet sütik: a böngésző bezárásáig</li>
                <li>Állandó sütik: meghatározott ideig (lásd táblázatok fent)</li>
                <li>Google Analytics sütik: maximum 2 év</li>
              </ul>
              <p className="text-gray-700">A pontos időtartam a használt süti típusától függ.</p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">6. SÜTI BEÁLLÍTÁSOK KEZELÉSE</h2>
              <p className="text-gray-700 mb-4">A Felhasználó jogosult:</p>
              <ul className="list-disc pl-6 text-gray-700 mb-4">
                <li>a sütikhez adott hozzájárulását bármikor módosítani vagy visszavonni;</li>
                <li>a sütiket böngészője beállításaiban törölni vagy letiltani.</li>
              </ul>

              <h3 className="text-xl font-semibold text-gray-900 mb-3">6.1. Hozzájárulás visszavonása</h3>
              <p className="text-gray-700 mb-4">
                A statisztikai sütikhez adott hozzájárulás a weboldalon található „Cookie beállítások" gombra kattintva bármikor visszavonható.
              </p>

              <h3 className="text-xl font-semibold text-gray-900 mb-3">6.2. Böngésző beállítások</h3>
              <p className="text-gray-700 mb-2">A sütik kezelésére vonatkozó útmutatók:</p>
              <ul className="list-disc pl-6 text-gray-700 mb-4">
                <li>Chrome: https://support.google.com/chrome/answer/95647</li>
                <li>Firefox: https://support.mozilla.org/kb/cookies</li>
                <li>Safari: https://support.apple.com/guide/safari/sfri11471</li>
                <li>Edge: https://support.microsoft.com/microsoft-edge/cookies</li>
              </ul>

              <h3 className="text-xl font-semibold text-gray-900 mb-3">6.3. Google Analytics letiltása</h3>
              <p className="text-gray-700 mb-4">
                A Google Analytics letiltható a Google által biztosított böngésző kiegészítővel: https://tools.google.com/dlpage/gaoptout
              </p>

              <p className="text-gray-700 font-semibold">
                FONTOS: a feltétlenül szükséges sütik letiltása a Szolgáltatás működésének korlátozását eredményezheti.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">7. JOGALAP</h2>
              <p className="text-gray-700 mb-2">A sütik alkalmazásának jogalapja:</p>
              <ul className="list-disc pl-6 text-gray-700 mb-4">
                <li>feltétlenül szükséges sütik: GDPR 6. cikk (1) f) – jogos érdek</li>
                <li>funkcionális sütik: GDPR 6. cikk (1) a) – hozzájárulás</li>
                <li>statisztikai sütik (Google Analytics): GDPR 6. cikk (1) a) – hozzájárulás</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">8. KAPCSOLAT AZ ADATKEZELÉSI TÁJÉKOZTATÓVAL</h2>
              <p className="text-gray-700">
                A sütik használatával kapcsolatos részletes adatkezelési információk az Adatkezelési Tájékoztatóban találhatók.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">9. A TÁJÉKOZTATÓ MÓDOSÍTÁSA</h2>
              <p className="text-gray-700">
                A Szolgáltató jogosult a jelen Süti Tájékoztatót módosítani. A módosítás a weboldalon történő közzététellel lép hatályba.
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}
